module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('span', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['-']),
      expression: "['-']"
    }],
    on: {
      "shortkey": _vm.commitNone
    }
  }), _c('div', {
    staticClass: "p-2"
  }, [_c('div', {
    staticClass: "pt-2 relative mx-auto text-gray-600 w-full"
  }, [_vm._m(0), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    ref: "search",
    staticClass: "pl-8 border-2 border-gray-300 bg-white h-10 px-5 pr-40 rounded-lg text-xs w-full focus:outline-none",
    attrs: {
      "type": "text",
      "placeholder": "Buscar"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "up", 38, $event.key, ["Up", "ArrowUp"])) { return null; }
        $event.stopPropagation();
        return _vm.highlightPrev.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "down", 40, $event.key, ["Down", "ArrowDown"])) { return null; }
        $event.stopPropagation();
        return _vm.highlightNext.apply(null, arguments)
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.commitSelection.apply(null, arguments)
      }],
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.close.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "absolute top-0 right-0 mt-4 pr-2 cursor-pointer",
    on: {
      "click": _vm.commitNone
    }
  }, [_c('i', {
    staticClass: "fas fa-minus-circle"
  })])])]), _c('div', {
    staticClass: "mt-2"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.isLoading) ? _c('div', {
    staticClass: "flex justify-center m-4 items-center w-full"
  }, [_c('i', {
    staticClass: "fas fa-circle-notch fa-spin fa-2x text-primary"
  })]) : _c('transition-group', {
    staticClass: "pl-2 pr-2",
    attrs: {
      "name": "slide-up",
      "tag": "div"
    }
  }, _vm._l((_vm.shadowList), function(item, index) {
    return _c('div', {
      key: index + 1,
      ref: "option",
      refInFor: true,
      staticClass: "flex bg-white border border-l-8 border-gray-200 rounded shadow mb-2 shadow-lg pl-2 cursor-pointer hover:bg-gray-200 hover:text-primary hover:border-primary",
      class: {
        'bg-gray-100': index === _vm.highlightedIndex,
        'text-primary': index === _vm.highlightedIndex,
        'border-primary': index === _vm.highlightedIndex
      },
      on: {
        "click": function($event) {
          return _vm.select(index)
        }
      }
    }, [_c('div', {
      staticClass: "flex items-center p-2"
    }, [_c('span', {
      staticClass: "flex-1 ml-5 font-bold"
    }, [_vm._v(_vm._s(item.nombre))])])])
  }), 0)], 1), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.shadowList.length === 0 && !_vm.isLoading),
      expression: "shadowList.length === 0 && !isLoading"
    }],
    staticClass: "px-3 py-2 text-purple"
  }, [_c('span', [_vm._v("No hay resultados para \"" + _vm._s(_vm.searchTerm) + "\"")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "absolute top-0 mt-4 pl-2"
  }, [_c('i', {
    staticClass: "fas fa-search"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e8bfddc","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/c_enfermera_seleccionar.vue
// module id = 232
// module chunks = 1